<template>
  <div class="container">
    <div class="topDiv">
        <div class="topLeft_div">
            <img class="topLeft_image" :src="common.userInfo.photoPath?common.userInfo.photoPath:require(`../../../assets/images/img_default_face_${common.theme}.jpg`)" />
            <div class="topLeft_div1">
                <span class="topLeft_span1">{{common.userTenantInfo.userName}}</span>
                <span class="topLeft_span2">{{common.userTenantInfo.department}}</span>
            </div>
        </div>
        <div class="topRight_div">
              <img class="topRight_icon" src="../../../assets/images/icon_arrows_black_left.png" @click="changeDay(0)" />
              <span class="topRight_span">{{newDatestr}}</span>
              <img class="topRight_icon" src="../../../assets/images/icon_arrows_black_right.png" @click="changeDay(1)" />
        </div>
    </div>
    <div class="bodyDiv">
        <div class="body_item">
            <span class="body_item_span1">出勤天数</span>
            <span class="body_item_span2">{{normal}}天</span>
        </div>
        <div class="body_item_line"></div>

        <div class="body_item" v-if="unNormal>0">
            <span class="body_item_span1">未打卡</span>
            <span class="body_item_span3">{{unNormal}}天</span>
        </div>
        <div class="body_item_line" v-if="unNormal>0"></div>
        <div class="body_item">
            <span class="body_item_span1">迟到</span>
            <span class="body_item_span3">{{late}}次</span>
        </div>
        <div class="body_item_line"></div>
    </div>
   <Tabbar :tab="2"></Tabbar>
 </div>
</template>
<script>
import Tabbar from "@/pages/smartOffice/StruggleReport/StruggleTabbar.vue";
import Scroll from "@/components/scroll";
import util from "@/utils/util";
import {getmonthReport} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            newDatestr:'',
            normal:0,
            unNormal:0,
            late:0,
        }
    },
    components:{
        Tabbar,
        Scroll
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
    created(){
        this.newDate = new Date();
        this.newDatestr = util.formatTime(new Date(),44)
        this.getmonthReport()
    },
     methods:{
         changeDay(flag){
            console.log("in changeDay" +flag);
            if(flag==1){
                var a=  new Date();
                if(a.getFullYear() == this.newDate.getFullYear() &&  this.newDate.getMonth()>=a.getMonth()){
                    return;
                }
                this.newDate.setMonth(this.newDate.getMonth()+1);
                this.newDatestr = util.formatTime(this.newDate,44)

            }else{

                if(this.newDate.getFullYear()==2020 && this.newDate.getMonth()==0){
                    return;
                }
                this.newDate.setMonth(this.newDate.getMonth()-1);
                this.newDatestr = util.formatTime(this.newDate,44)
            }
            //console.log("in changeDay" + this.newDate)
            this.getmonthReport();

        },
         getmonthReport(){
             let params = {
               // companyId:'2',
                month:this.newDatestr,
                companyId:this.common.userTenantInfo.companyId,
            }
            console.log('params == ' +JSON.stringify(params))
            getmonthReport(params).then(res => {
                if (res.res.code === 10000 && res.body) {
                    this.normal =res.body.normal;
                    this.unNormal =res.body.unNormal;
                    this.late = res.body.late;
                   // "normal":1,"unNormal":0,"late":0
                }
            })
         }
     },
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
    //height:100vh;
    background:#FFFFFF;
}
.topDiv{
    width:100%;
    height:120px;
    background:rgba(255,255,255,1);
    box-shadow:0px 8px 16px 0px rgba(0,0,0,0.04);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}
.topLeft_div{
    flex-direction: row;
    height:120px;
    align-items: center;
    display: flex;
    margin-left: 28px;
}
.topLeft_image{
    width:80px;
    height:80px;
    border-radius:40px ;
    // border:1px solid rgba(182,196,248,1);
}
.topLeft_div1{
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    height:80px;
}
.topLeft_span1{
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.topLeft_span2{
    margin-top: 2px;
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;
}


.topRight_div{
    display: flex;
    margin-right: 28px;
    align-items: center;
    flex-direction: row;
}
.topRight_icon{
    width: 32px;
    height: 32px;
}
.topRight_span{
    margin-top: 2px;
    height:48px;
    font-size:32px;
    margin-left: 12px;
    margin-right: 12px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:48px;
}

.bodyDiv{
    margin-top: 20px;
    width: 100%;
    flex: 1;
    flex-direction: column;
    display: flex;
}
.body_item{
    width: 100%;
    height:100px;
    background:rgba(255,255,255,1);
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.body_item_span1{
    height:44px;
    margin-left: 40px;
    font-size:32px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.body_item_span2{
    height:44px;
    margin-right: 40px;
    font-size:32px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.body_item_span3{
    height:44px;
    margin-right: 40px;
    font-size:32px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:44px;
}
.body_item_line{
    margin-left: 40px;
    margin-right: 40px;
    height: 2px;
    width: 694px;
    display: flex;
    background:rgba(240,240,240,1);
}

</style>